import { h, resolveComponent } from 'vue';
import { isAuth } from '@/services/PermissionService';
import Content from '@/components/layout/Content';
import Names from './names';
import { hasPermission, MANAGER, OWNER, SUPER_ADMIN } from '@/middlewares/permissions';

const routerView = {
	render() {
		return h(resolveComponent('router-view'));
	},
};

export default {
	path: '/business',
	component: Content,
	children: [
		{
			path: ':id?',
			component: routerView,
			meta: {
				middleware: [isAuth],
			},
			children: [
				{
					path: 'menu',
					name: Names.BusinessMenu,
					component: () => import('../views/menu/Menu'),
					props: (route) => ({ businessName: route.query.n }),
				},
				{
					path: 'toppings',
					name: Names.ToppingsList,
					component: () => import('../views/menu/Toppings'),
					props: (route) => ({ businessName: route.query.n }),
				},
				{
					path: 'top/items',
					name: Names.TopProducts,
					component: () => import('../views/menu/TopProducts'),
					meta: {
						title: 'Top products',
						middleware: [isAuth, (nav) => hasPermission(nav, [OWNER], [SUPER_ADMIN, OWNER, MANAGER])],
					},
					props: (route) => ({ businessName: route.query.n }),
				},
			],
		},
		{
			path: 'my',
			name: Names.MyBusinesses,
			component: () => import('../views/menu/MyBusinesses'),
			meta: {
				title: 'My Businesses',
				middleware: [isAuth],
			},
		},
	],
};
